module.exports = __webpack_public_path__ + "static/media/GuessTheNumberSS.dd73bbfc.png";